export default __webpack_public_path__ + "static/media/Background_00022.77915318.png";